import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    // Idempotent-once: prevent double-run under StrictMode
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      navigate("/admin/contacts", { replace: true });
      return;
    }

    (async () => {
      try {
        await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
      } catch {
        // fall through — protected page will surface unauth state
      } finally {
        // strip hash and redirect to admin console
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/admin/contacts", { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <main className="min-h-screen bg-[#050505] text-[#F5F5F5] flex items-center justify-center">
      <div className="font-['JetBrains_Mono'] text-[11px] tracking-[0.3em] text-[#A1A1AA]">
        &gt;_ EXCHANGING_HANDSHAKE<span className="cursor-blink">_</span>
      </div>
    </main>
  );
}
